export const ARRAY_DYNAMIC_INTEGRAL_SALARY_WAGE_VALUES = ['year', 'year_variable_type', 'year_variable'];
export const SALARY_CODE = 'SALARY';
export const COLOMBIA_COUNTRY = 'Colombia';
export const MIN_COLOMBIA_SALARY = 1160000;
export const BANK_OTHER_ID = '76324D89-B73B-4A94-8B7B-0B24DF6AC8ED';
export const CURRENT_MONTH = 1;
export enum typesAddress {
    first = 1,
    second = 2,
    cardinal = 3,
}
export const IMG_STEP = 'https://nominaenlineastoragetest.blob.core.windows.net/front-images/nel-header-datos-step-3.png';

export const MAPPING_PAYMENT_FORM = {
    'holder.firstname': 'firstName',
    'holder.secondname': 'middleName',
    'holder.firstlastname': 'lastName',
    'holder.secondlastname': 'secondLastName',
    'holder.companyname': 'businessName',
    'holder.dv': 'dv',
    'holder.document_number': 'number',
};

export const COMPANY_DATA_FORM = {
    first_name: 'firstName',
    second_name: 'middleName',
    first_last_name: 'lastName',
    second_last_name: 'secondLastName',
    company_name: 'businessName',
    dv: 'dv',
    document_number: 'number',
};
